<div (click)="menu?.toggle($event)" class="d-flex align-items-center">
  <div class="user-info d-none d-lg-inline-block">
    <span class="d-block user-name">{{ user?.name }}</span>
    <span class="d-block user-email">{{ user?.email }}</span>
  </div>

  <div class="menu-cta">
    <i class="mynaui-dots-vertical"></i>
  </div>

  <div class="d-lg-none d-flex menu-cta m-2" (click)="openMobileSidebar($event)">
    <i [class]="mobileSidebarExpanded ? 'mynaui-x' : 'mynaui-menu'"></i>
  </div>

  <p-popover styleClass="user-menu-panel cap-overlay-panel header-title-bar" #menu appendTo="body">
    <div class="user-menu">
      <ul class="user-menu__items" [formGroup]="form">
        @for (item of menuItems; track item) {
          <li (click)="executeCommand(item, $event)" [class.disabled]="item.disabled">
            @switch (item.type) {
              @case (menuType.Template) {
                @if (templates() | menuItemTemplate: item.key; as template) {
                  <ng-container
                    [ngTemplateOutlet]="templates() | menuItemTemplate: item.key"
                    [ngTemplateOutletContext]="{ item: item }" />
                }
              }

              @default {
                <i [className]="item?.icon"></i>
                <span>{{ item?.label | translate }}</span>
              }
            }
          </li>
        }

        <ng-template capTemplate="language" let-item="item">
          <div class="language-selector">
            <span class="flag flag-{{ form.get('currentLanguage').value }}"></span>
            <cap-dropdown
              [options]="languages"
              formControlName="currentLanguage"
              (changeSelection)="changeLanguage($event)"
              [sortAlphabetically]="false" />
          </div>
        </ng-template>

        <ng-template capTemplate="tenant" let-item="item">
          <div class="tenant-switcher">
            <i [className]="item?.icon"></i>

            <cap-dropdown
              [options]="tenantList()"
              optionDisabled="disabled"
              formControlName="tenantRef"
              (changeSelection)="switchTenant($event)"
              [filter]="true">
              <ng-template capTemplate="item" let-item>
                <ng-container [ngTemplateOutlet]="tenantItem" [ngTemplateOutletContext]="{ $implicit: item }" />
              </ng-template>
              <ng-template capTemplate="selectedItem" let-item>
                <ng-container [ngTemplateOutlet]="tenantItem" [ngTemplateOutletContext]="{ $implicit: item }" />
              </ng-template>
            </cap-dropdown>

            <ng-template #tenantItem let-item>
              <span class="tenant-name">{{ item.label }}</span>

              @if (item.status === tenantStatus.INACTIVE || item.status === tenantStatus.INVITED) {
                <span
                  class="tenant-status"
                  [pTooltip]="
                    (item.status === tenantStatus.INVITED
                      ? 'tenant-ref-selector.invited.tooltip'
                      : 'tenant-ref-selector.inactive.tooltip'
                    ) | translate
                  "
                  tooltipPosition="left"
                  tooltipStyleClass="neqto-tooltip">
                  <i class="warning mynaui-danger-triangle"></i>
                </span>
              }
            </ng-template>
          </div>
        </ng-template>
      </ul>
    </div>
  </p-popover>
</div>
